import { render } from "./NewCoverType.vue?vue&type=template&id=7b3bcd2f"
import script from "./NewCoverType.vue?vue&type=script&lang=js"
export * from "./NewCoverType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__